// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".pickup-specifics-modal__select[data-v-2cec08ac]{padding:2px 12px!important}.pickup-specifics-modal__actions[data-v-2cec08ac]{margin-top:100px}@media(max-width:500px){.pickup-specifics-modal__inputs[data-v-2cec08ac]{flex-direction:column;gap:16px 0}}.pickup-specifics-modal__inputs>div[data-v-2cec08ac]{flex:1}", ""]);
// Exports
module.exports = exports;
